import * as _4 from 'lodash4';
import { IRegistrationActivityDatasource } from '../../registration_transactions/datasources/registration_activity_datasource';

export class RegistrationReceiptServant {
  constructor(private ngRegistrationActivityDatasource: IRegistrationActivityDatasource) {}

  getReceiptData(sections: number[] = []) {
    const registrationActivityData = this.ngRegistrationActivityDatasource.values();
    const receiptData = _4.map(registrationActivityData, (activity) => {
      let sectionId = -1;
      let sectionName = '';
      const context = activity.context;
      const message = activity.message;
      const success = activity.alert_type === 'success';
      const isActiveRecord = activity.is_active;
      const transactionId = activity.transaction_id;
      const transactionDate = moment(activity.created_ts).format('MMM DD, YYYY LT');
      let action = '';
      if (context) {
        const sectionType = _4.get(context, 'section_type', '');
        sectionId = context.section_id;
        const sectionTypeAppend = !_4.isEmpty(sectionType) ? ` - ${sectionType}` : '';
        sectionName = `${context.section_name}${sectionTypeAppend}`;
        action = context.action;
      }
      return {
        id: activity.id,
        section_id: sectionId,
        title: `${sectionName}`,
        message,
        success,
        action,
        transactionDate,
        isActiveRecord,
        transactionId
      };
    });
    if (!_4.isEmpty(sections)) {
      return _4.filter(receiptData, (receipt) => _4.includes(sections, receipt.section_id) && receipt.isActiveRecord);
    }
    return receiptData;
  }
}

angular.module('capability-ng-scheduler').service('ngRegistrationReceiptServant', RegistrationReceiptServant);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/servants/registration_receipt_servant.ts